<template>
  <v-app id="app">
    <v-card id="app-wrapper" class="wrapper">
      <link href="https://cdn.jsdelivr.net/npm/animate.css@3.5.1" rel="stylesheet" type="text/css" />

      <router-view v-animate-css="transitonName" :key="$store.state.contentKey" class="content" />

      <div
        v-animate-css="navAnimation"
        v-if="this.$route.path !== ('/')
          && !this.$route.path.includes('/intro')
          && !this.$route.path.includes('/login')
          && !this.$route.path.includes('/payment')
          && !this.$route.path.includes('/cancelation')
          && this.$route.path!==('/chat')
          && !this.$route.path.includes('/chat')
          && !this.$route.path.includes('/activate')
          && !this.$route.path.includes('/stripe/process')
          && !this.$route.path.includes('/register')
          && !this.$route.path.includes('/update')"
        class="nav"
      >
        <router-link to="home" style="padding-bottom: 10px;">
          <img v-if="$route.path.includes('/home')" src="@/assets/icons/home_active.png" alt />
          <img v-else src="@/assets/icons/home.png" alt />
          <div class="nav__descr">Dashboard</div>
        </router-link>

        <div>
          <router-link
            :class="[
              'home-button',
              { activeMenu },
              { 'home-button__glowing': isHomeGlowing }
            ]"
            to="match"
          >
            <img v-if="activeMenu" src="@/assets/icons/ball-white.png" alt />
            <img v-else src="@/assets/icons/ball-green.png" alt />
          </router-link>
          <div class="nav__descr nav__descr--middle" :class="{ 'nav__descr--active': ($route.path.includes('match') || $route.path.includes('search')) && !$route.path.includes('/matches') }">Matching</div>
        </div>

        <router-link to="matches" style="padding-bottom: 10px;">
          <v-badge
            v-if="newMatch"
            v-animate-css="'tada'"
            color="green"
          >
            <template v-slot:badge><v-icon color="white">sports_soccer</v-icon></template>
            <img v-if="$route.path.includes('/matches')" src="@/assets/icons/chat_active.png" alt />
            <img v-else src="@/assets/icons/chat.png" alt />
          </v-badge>
          <v-badge
            v-else-if="newMessagesCount > 0"
            v-animate-css="'tada'"
            color="red"
          >
            <template v-slot:badge>{{ newMessagesCount }}</template>
            <img v-if="$route.path.includes('/matches')" src="@/assets/icons/chat_active.png" alt />
            <img v-else src="@/assets/icons/chat.png" alt />
          </v-badge>
          <div v-else>
            <img v-if="$route.path.includes('/matches')" src="@/assets/icons/chat_active.png" alt />
            <img v-else src="@/assets/icons/chat.png" alt />
          </div>
          <div class="nav__descr">Chats</div>
        </router-link>
      </div>

      <v-snackbar class="snack snack-green" :top="true" v-model="$store.state.snackbar">
        <b>
          {{ $store.state.snackText }}
        </b>
        <v-btn color="red" flat icon @click="$store.state.snackbar = false">
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </v-snackbar>

      <v-snackbar class="snack snack-green" :top="true" :timeout="0" v-model="askForPushPermition">
        <b>
          Möchtest du Push-Message erlauben?
        </b>
        <v-btn color="white" flat icon @click="requestSafariPersission(); $store.state.askForPushPermition = false">
          <v-icon>check_circle_outline</v-icon>
        </v-btn>
        <v-btn color="red" flat icon @click="$store.state.askForPushPermition = false">
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </v-snackbar>

      <transition name="fade">
        <div v-if="$store.state.loading" v-animate-css="'fadeOut'" class="loading-screen">
          <div class="loading-spinner">
            <v-progress-circular indeterminate color="green" size="40"></v-progress-circular>
          </div>
        </div>
      </transition>

      <v-dialog persistent v-model="showAccountVerifiedPopup" max-width="290">
        <v-card class="text-center">
          <v-card-title class="headline headline__green" style="justify-content: center;">
            {{ userTypeNotLogged === 'teams' ? 'Euer' : 'Dein' }} Account wurde erfolgreich verifiziert.
          </v-card-title>

          <v-card-text class="">
            <b style="font-size: 16px">Unser Tipp</b>
            <br /><br />
            <span class="green-text text-bold">
              Installiere jetzt die C4T-Plattform auf dem Homescreen deines Endgerätes als Webapp und nutze sie als herkömmliche App.
            </span>
          </v-card-text>

          <v-card-actions style="justify-content: center;">
            <v-btn color="green--text" text @click="openPage('account-verified')">Wie?</v-btn>
            <v-btn color="green white--text" text @click="showAccountVerifiedPopup = false">Mach ich</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="$store.state.logout_dialog" max-width="290">
        <v-card class="text-left">
          <v-card-title class="headline">Logout</v-card-title>

          <v-card-text>Bist du sicher, dass du dich ausloggen möchtest?</v-card-text>

          <v-card-actions style="justify-content: center;">
            <v-btn color="green--text" text @click="$store.state.logout_dialog = false">Schließen</v-btn>
            <v-btn color="green white--text" text @click="signOut">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="400" v-model="dialog">
        <v-card class="install-card">
          <p>Du kannst die C4T-Website auch als App installieren, somit ist die Bedienung unterwegs noch schneller und einfacher. Klicke dazu auf den Button und schau auf deinen Homescreen.</p>
          <v-btn
            color="green white--text"
            style="cursor:pointer"
            :style="{'display': installBtn}"
            @click="installer()"
          >Installieren</v-btn>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="$store.state.buy_swipes_dialog" max-width="290">
        <v-card class="text-center">
          <v-card-title class="headline headline__green" style="justify-content: center;">Neue Swipes</v-card-title>

          <v-card-text class="">
            <b>Du erhältst in sieben Tagen kostenlos 5 Free Swipes.</b>
            <br /><br />
            <b style="color: green">Du möchtest sofort neue Swipes zur Verfügung haben?
            Dann wähle ein passendes Swipe-Package aus und connecte weitere Vereine!</b>
          </v-card-text>

          <v-card-actions style="justify-content: center;">
            <v-btn color="green--text" text @click="openPage('buy-swipes'); $store.state.showPaymentsBlock = true; $store.state.buy_swipes_dialog = false">Swipe-Package</v-btn>
            <v-btn color="green white--text" text @click="$store.state.buy_swipes_dialog = false">Free Swipes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-app>
</template>

<script>
import firebase from 'firebase';
import { mapState } from 'vuex';
import Axios from 'axios';
import { db } from './db';
import common from './mixins/common';
import pushNotificationsMixin from './mixins/push-notifications';
import { cloudFunctions } from './config';


export default {
  data: () => ({
    user: '',
    transitonName: {
      classes: 'fadeIn',
      delay: 0,
      duration: 800,
    },
    documents: [],
    installBtn: 'block',
    installer: undefined,
    dialog: false,
    navAnimation: {
      classes: 'slideInUp',
      delay: 0,
      duration: 400,
    },
    showAccountVerifiedPopup: false,
    userTypeNotLogged: 'users',
  }),

  mixins: [common, pushNotificationsMixin],

  methods: {
    openPage(destination) {
      switch (destination) {
        case 'account-verified':
          window.location.href = 'https://chance4talents.de/#webapp';
          break;
        case 'buy-swipes':
          if (this.$route.name !== 'match' && this.$route.name !== 'trainer_match') {
            this.$router.push({ name: this.user_data.userType === 'player' ? 'match' : 'trainer_match' });
          }
          break;

        default:
          break;
      }
    },

    signOut() {
      this.$store.state.logout_dialog = false;
      const myConnectionsRef = firebase.database().ref(`user_status/${this.user_data.id}/connected`);
      const lastOnlineRef = firebase.database().ref(`user_status/${this.user_data.id}/lastOnline`);

      myConnectionsRef.set(false);
      lastOnlineRef.set(firebase.database.ServerValue.TIMESTAMP);

      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.state.accountDeleted = false; // to check in app why user is null
          this.$router.push({ name: 'login' });
          this.$store.state.players = [];
          this.$store.state.trainers = [];
          this.$store.state.payments = [];
          this.$store.commit('setSubscriptionData', null);
          this.$store.user_data = {};
          // remove it because of problems if you use multiple account in one browser
          // it will be added by vuefire? after login for accout
          localStorage.removeItem('vuex');
          localStorage.removeItem('@firebase/performance/config');
          localStorage.removeItem('@firebase/performance/configexpire');

          this.bindUserUnsubscribe();
        },
        (error) => {
          // An error happened.
        });
    },
  },

  watch: {
    $route(to, from) {
      if (from.name === 'match' && to.name === 'settings') {
        this.transitonName.classes = 'slideInLeft';
      } else if (from.name === 'home' && to.name === 'match') {
        this.transitonName.classes = 'slideInRight';
      } else if (from.name === 'match' && to.name === 'matches') {
        this.transitonName.classes = 'slideInRight';
      } else if (from.name === 'matches' && to.name === 'match') {
        this.transitonName.classes = 'slideInLeft';
      } else if (from.name === 'matches' && to.name === 'settings') {
        this.transitonName.classes = 'slideInLeft';
      } else if (from.name === 'home' && to.name === 'matches') {
        this.transitonName.classes = 'slideInRight';
      } else {
        this.transitonName.classes = 'fadeIn';
      }
    },

    async bindedUserData(newVal) {
      if (newVal) {
        console.log('binded data triggered');

        this.$store.state.watchUserDataActive = false;
        await this.fetchChats(newVal.matches);

        if (newVal.newMatchId && this.userMatches.some(m => m.chat_id === newVal.newMatchId)) {
          this.$store.state.newMatch = true;

          if (this.isIOS) {
            if (this.user_data.userType && (this.user_data.userType !== 'scouts' || this.user_data.userType !== 'teams')) {
              this.$store.commit({
                type: 'openSnackbar',
                text: 'Du hast ein neues Match! ⚽️',
              });
            }
          }
        } else if (this.userType === 'users' || this.userType === 'trainers') {
          this.$store.state.newMatch = false;
          db.collection(this.userType)
            .doc(this.user_data.id)
            .update({
              newMatchId: null,
            });
        }

        if (this.isIOS) {
          if (newVal.newApplication && this.userType === 'teams') {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Du hast eine neue Connect-Anfrage! ⚽️',
            });
          }
        }

        if (this.userMatches) {
          const newMessagesCount = this.userMatches
            // don't show new message bubble if chat was blocked by sender
            // .filter(m => !m.inactive || !m.inactive.status || (m.inactive && m.inactive.status && m.inactive.blockedBy === this.user_data.id))
            .filter(m => m.lastMessageDetails && m.lastMessageDetails.creatorId !== newVal.id && !m.lastMessageDetails.recieverRead)
            .length;

          this.$store.state.newMessagesCount = newMessagesCount;
        }
        this.$store.state.watchUserDataActive = true;
      }

      // if (oldVal) {
      //   if (oldVal.matches && oldVal.matches.length < newVal.matches.length) {
      //     this.$store.state.newMatch = true;

      //     if (this.user_data.userType && (this.user_data.userType !== 'scouts' || this.user_data.userType !== 'teams')) {
      //       this.$store.commit({
      //         type: 'openSnackbar',
      //         text: 'Du hast ein neues Match! ⚽️',
      //       });
      //     }
      //   }
      // }
    },

    // async user_data(newVal) {
    //   console.log('user data:', newVal);
    //   this.setDefaultMessagingSettings(newVal);
    // },
  },

  computed: {
    ...mapState([
      'user_data',
      'newMatch',
      'newApplication',
      'userType',
      'bindedUserData',
      'userMatches',
      'newMessagesCount',
      'bindUserUnsubscribe',
    ]),

    activeMenu() {
      return (this.$route.path.includes('match') || this.$route.path.includes('search')) && !this.$route.path.includes('/matches');
    },

    isHomeGlowing() {
      // if (this.newMatch && this.user_data && this.userType !== 'teams') {
      if (this.newMatch) {
        return true;
      }

      if (this.user_data && this.user_data.newApplication && this.userType === 'teams') {
        return true;
      }

      return false;
    },
  },

  mounted() {
    // navigator.pushManager.ready((reg) => {
    //   reg.pushManager.getSubscription().then((sub) => {
    //     if (!sub) {
    //       console.log('Ask user');
    //     } else {
    //       console.log('update db');
    //     }
    //   });
    // });

    document.getElementById('app').addEventListener('touchstart', (e) => {
      // is not near edge of view, exit
      const posX = e.touches[0].clientX || 0;
      const windowWidth = window.innerWidth - 10;
      if (posX >= 17 && posX < windowWidth) return;

      // prevent swipe to navigate gesture
      e.preventDefault();
    }, { passive: false });
  },

  created() {
    this.$store.userMatches = null;
    this.$store.newMatch = false;
    this.$store.state.snackbar = false;
    this.$store.state.loading = false;
    this.$store.state.user_data = {};
    this.$store.state.user_uid = null;

    if (this.$messaging) {
      this.$messaging.onMessage((payload) => {
        console.log('Message receiver ', payload);
        this.$store.commit({
          type: 'openSnackbar',
          text: payload.data.body,
        });
      });
    }

    if ('setAppBadge' in navigator && 'clearAppBadge' in navigator) {
      this.$store.state.badgeApiPresent = true;
    }

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // for chat online users
        const myConnectionsRef = firebase.database().ref(`user_status/${user.uid}/connected`);
        const lastOnlineRef = firebase.database().ref(`user_status/${user.uid}/lastOnline`);
        const connectedRef = firebase.database().ref('.info/connected');

        connectedRef.on('value', (snap) => {
          if (snap.val() === true) {
            // When I disconnect
            myConnectionsRef.onDisconnect().set(false);

            myConnectionsRef.set(true);

            // When I disconnect, update the last time I was seen online
            lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
          }
        });
      }
      console.log(user, this.$store.state.accountDeleted);
      // user is null after delete
      if (user === null && this.$store.state.accountDeleted === true) {
        this.$router.push({ name: 'cancelation' });
        return;
      }

      if (user && user.uid !== this.$store.state.user_data.id) {
        console.log('user rozny');
        // redirect from stripe (giropay, sofort)

        if (window.location.search.includes('payment_intent')) {
          const queryString = window.location.search.substring(1);
          const queries = queryString.split('&');
          const queryValues = {};

          queries.forEach((q) => {
            const [key, value] = q.split('=');
            queryValues[key] = value;
          });
          console.log('sripe route query parms:', queryValues);

          db.collection(user.displayName)
            .doc(user.uid)
            .get()
            .then((snapshot) => {
              const doc = snapshot.data();
              this.$store.state.user_id = user.uid;
              this.$store.state.userType = user.displayName;
              this.$store.state.user_data = doc;

              return doc;
            })
            .then(async (userData) => {
              await this.fetchChats(userData.matches);
              return userData;
            })
            .then(async (userData) => {
              this.$store.dispatch('bindUserData');
              await this.setDefaultMessagingSettings(userData);
            })
            .then(() => {
              this.$router
                .push({
                  name: 'stripe_process',
                  params: {
                    payment_intent: queryValues.payment_intent,
                    redirect_status: queryValues.redirect_status,
                    payment_intent_client_secret: queryValues.payment_intent_client_secret,
                  },
                });
            });
        } else {
          db.collection(user.displayName)
            .doc(user.uid)
            .get()
            .then((snapshot) => {
              const doc = snapshot.data();
              this.$store.state.user_id = user.uid;
              this.$store.state.userType = user.displayName;
              this.$store.state.user_data = doc;

              return doc;
            })
            .then(async (userData) => {
              await this.fetchChats(userData.matches);
              await this.setDefaultMessagingSettings(userData);
            })
            .then(() => {
              this.$store.dispatch('bindUserData');
            })
            .then(() => {
              this.$store.dispatch('loadUserWatchlist');
            })
            .then(() => {
              this.$store.dispatch('setSubscriptionData');
              this.$store.dispatch('setUserPayments');
              if (this.$messaging) {
                this.messagingInit();
                this.messagingRegister(null);
              }
              console.log('debug: app entry, call checkSafariPushNotifications with null');
              this.checkSafariPushNoifications(null);
            })
            .then(() => {
              this.$store.state.loading = false;
              this.redirectToUserType(this.userType);
              if (this.$store.state.user_data.fullyFilled) {
                this.$store.commit({
                  type: 'openSnackbar',
                  text: 'Erfolgreich wieder eingeloggt',
                });
              }
            })
            .then(() => {
              const daysForFreeSwipes = this.howManyDaysFromLastSwipeUsed();
              if (this.$store.state.user_data.swipesLeft === 0) {
                if (daysForFreeSwipes >= 7) {
                  this.$store.dispatch('setUserFreeSwipes');
                } else {
                  this.$store.state.buy_swipes_dialog = true;
                }
              }
            });
        }
      } else if (!this.$route.path.includes('/register') && !this.$route.path.includes('/activate') && !this.$route.path.includes('/cancelation')) {
        this.$store.state.loading = false;
        this.$router.push({ name: 'login' });
      } else if (this.$route.path.includes('/cancelation')) {
        this.$router.push({ name: 'cancelation' });
      } else if (this.$route.path.includes('/register')) {
        // do nothing, let it throug to register page
      } else if (this.$route.path.includes('/activate')) {
        const params = this.$route.path.split('/');
        const url = `${cloudFunctions}/activateAccount?uid=${params[2]}&type=${params[3]}`;

        this.userTypeNotLogged = params[3];
        Axios({
          method: 'get',
          url,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }).then(() => {
          this.showAccountVerifiedPopup = true;
        });

        this.$router.push({ name: 'login' });
      } else {
        this.$router.push({ name: 'login' });
      }
    });
  },
};
</script>

<style scoped>
  .v-badge__badge .v-icon {
    font-size: 18px;
  }
</style>
